import React from 'react'
import Container from '@material-ui/core/Container'
import BuildIcon from '@material-ui/icons/Build'
import { PageHeader } from 'components/page-header'
import EmptyPageState from 'components/empty-page-state'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import StreamMessagesPage from './stream'

const MessagingPage = () => {
  const [enabledMessagingService] = useFeatureFlags([
    flags.FLAG_MESSAGING_SERVICE,
  ])

  switch (enabledMessagingService) {
    case 'stream':
      return <StreamMessagesPage />
    case 'maintenance':
    default:
      return (
        <>
          <PageHeader
            title="Messaging"
            crumbs={[
              {
                to: '/pga-coach',
                label: 'Home',
              },
            ]}
          />
          <Container maxWidth="sm">
            <EmptyPageState
              IconComp={() => <BuildIcon />}
              title="Under Maintenance"
              caption="We are currently in the process of upgrading your messaging experience! Please check back again in just a bit. 👍"
              removeButton
            />
          </Container>
        </>
      )
  }
}

export default MessagingPage
